import React from 'react'
import {
    // Box,
    // Typography,
    FormControl,
    // FilledInput,
    InputAdornment,
    // InputLabel,
    IconButton,
    // TextField,
    Input,
  } from "@mui/material";
  import SearchIcon from "@mui/icons-material/Search";
  import {styled} from '@mui/material/styles'
function InputSearch({placeholder}) {
  return (
    <FormControl
          sx={{
            m: 1,
            width: "34ch",
            background: (theme) => theme.palette.redBold.main,
            color: "white",
            padding:'3px',
            borderRadius:"8px",
          }}
          variant="standard"
        >
          <InputText
            id="standard-adornment-password"
            type={"text"}
            placeholder={placeholder}
            inputProps={{
              sx: {
           
                "&::placeholder": {
                  color: "white",
                  fontWeight: 500,
                  opacity: 1, // otherwise firefox shows a lighter color
                },
              },
            }}
            startAdornment={
              <InputAdornment position="start">
                <IconButton
                  color='white'
                  aria-label="toggle password visibility"
                  // onClick={handleClickShowPassword}
                  // onMouseDown={handleMouseDownPassword}
                >
                  <SearchIcon sx={{color:'white'}}  />
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
  )
}


const InputText = styled(Input)({
    "&::placeholder": {
      color: "white",
    },
    "&::before": {
      border: 0,
      "&:hover": {
        border: 0,
      },
    },
  });
export default InputSearch